'use client';

import { useRef } from 'react';
import classNames from 'classnames';
import { sendCtaClickEvent } from '@/features/analytics/datalayer/datalayer';
import { AppNextLink } from '@/features/app-next-link';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import { elementTrackingId } from '@/app/(home-page)/_components/contants';
import { useCustomAttributes } from '@/app/(home-page)/_components/utils/use-custom-attr';
import HeaderBannerSkeleton from './header-banner/skeleton';
import { useGetHeaderBanner } from '../utils/header-banner';
import { validateBannerLinkHandler } from '../utils/validate-banner-link';
interface Props {
  className?: string;
}
const HeaderBanner = ({
  className
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    data,
    isLoading
  } = useGetHeaderBanner();
  const linkRef = useRef<HTMLAnchorElement>(null);
  useCustomAttributes(linkRef, {
    elementTrackingId: elementTrackingId,
    elementName: 'top_header'
  });
  if (isLoading) return <HeaderBannerSkeleton />;
  if (!data) return null;
  const handleClick = () => {
    sendCtaClickEvent({
      elementType: 'HeaderBanner',
      elementName: 'HeaderBanner',
      elementIndex: 0,
      destinationUrl: data?.link ?? '',
      ImageUrl: isMobile ? data?.mobileImageUrl : data?.desktopImageUrl,
      itemID: data?.id?.toString() ?? ''
    });
    Webengage.trackCtaAction({
      banner_type: 'HeaderBanner',
      banner_name: 'HeaderBanner',
      banner_index: '0',
      url_destination: data?.link || '',
      item_id: data?.id?.toString() || '',
      component_id: '',
      image_url: (isMobile ? data?.mobileImageUrl : data?.desktopImageUrl) ?? ''
    });
  };
  return <AppNextLink ref={linkRef} href={validateBannerLinkHandler(data.link || '') ?? ''} prefetch={false} className={classNames('block h-10 w-full lg:h-[60px]', className)} onClick={handleClick} data-sentry-element="AppNextLink" data-sentry-component="HeaderBanner" data-sentry-source-file="header-banner.tsx">
            <picture data-sentry-element="picture" data-sentry-source-file="header-banner.tsx">
                <source media='(min-width: 1200px)' srcSet={data?.desktopImageUrl || ''} />
                <img src={data?.mobileImageUrl || ''} alt={data.title || 'بنر هدر'} className='h-full w-full object-cover' />
            </picture>
        </AppNextLink>;
};
export default HeaderBanner;